














































import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import requests from '@/helpers/requests'
import SuccessWareHost from './successware-host.json'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    host: string|null;
    agentName: string|null;
    agentPassword: string|null;
    masterId: string|null;
    companyNumber: string|null;
    departmentNumber: string[];
}


interface Settings {
    host: string|null;
    agentName: string|null;
    agentPassword: string|null;
    masterId: string|null;
    companyNo: string|null;
    departmentNumber: string|null;
}


interface LoadData {
    settings: Settings;
}


interface LoadResponse {
    data: LoadData;
    message: string;
    status: number;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SetupSuccessWareIntegration extends Vue {
    locationValid = false
    currentInformation: object|null = null
    loadingInformation = false
    loadInformationErrorMessage: string|null = null
    settings: object|null = null
    pulsemAccountId: number|null = null
    host = ''
    hostValue = ''
    agentName: string|null = null
    agentPassword: string|null = null
    masterId: string|null = null
    companyNumber: string|null = null
    departmentNumbers: string[] = []
    SuccessWareHost = SuccessWareHost

    /**
     * Select the correct host that will be sent to the server, based on the customers SW setup.
     * @returns string
     */
    get requestedHost(): string {
        return this.hostValue === SuccessWareHost.LAN ? this.host : this.hostValue
    }

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            host: this.requestedHost,
            agentName: this.agentName,
            agentPassword: this.agentPassword,
            masterId: this.masterId,
            companyNumber: this.companyNumber,
            departmentNumber: this.departmentNumbers
        }
    }

    async onLocationChange(locationValid: boolean) {
        this.loadInformationErrorMessage = null
        if (locationValid) {
            this.loadingInformation = true
            try {
                const response = await requests.post('/support/successware/load-integration', {
                    pulsemAccountId: this.pulsemAccountId
                }) as LoadResponse
                this.loadInformationErrorMessage = null
                this.currentInformation = response.data.settings
                this.locationValid = locationValid
            } catch(e) {
                this.loadInformationErrorMessage = e.message
                this.currentInformation = null
                this.locationValid = false
            }
            this.loadingInformation = false
        } else {
            this.loadInformationErrorMessage = null
            this.currentInformation = null
            this.locationValid = false
            this.loadingInformation = false
        }
    }

    onSuccess() {
        // No need to do anything on this one since data needs to be displayed.
    }
}
